import { ArrowRight } from "lucide-react";
import type { ContentItem } from "../content/types";
import { formatDate, readingMinutes } from "../lib/article";

type ArticleCardProps = {
  article: ContentItem;
  featured?: boolean;
  headingLevel?: "h2" | "h3";
};

export function ArticleCard({ article, featured = false, headingLevel: Heading = "h3" }: ArticleCardProps) {
  const category = article.categories[0] ?? "Aquarium guide";
  const minutes = readingMinutes(article.contentHtml);

  return (
    <article className={`article-card${featured ? " article-card--featured" : ""}`}>
      <a className="article-card__media" href={article.canonicalPath} tabIndex={-1} aria-hidden="true">
        {article.featuredImage ? (
          <img src={article.featuredImage} alt="" loading={featured ? "eager" : "lazy"} />
        ) : (
          <span className="article-card__pattern" />
        )}
      </a>
      <div className="article-card__body">
        <p className="article-card__meta">
          <span>{category}</span>
          <span aria-hidden="true">·</span>
          <span>{minutes} min read</span>
          <span aria-hidden="true">·</span>
          <time dateTime={article.publishedAt}>{formatDate(article.publishedAt, "short")}</time>
        </p>
        <Heading className="article-card__title">
          <a href={article.canonicalPath}>{article.title}</a>
        </Heading>
        <p className="article-card__summary">{article.summary}</p>
        <span className="article-card__cue" aria-hidden="true">
          Read guide <ArrowRight size={16} strokeWidth={2.2} />
        </span>
      </div>
    </article>
  );
}
